/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

setTimeout(function () {
  ProductItemHoverEffect();
}, 1000)

function ProductItemHoverEffect() {
  const queryString = window.location.pathname; 
  const elements = document.getElementsByClassName('ProductItem');

  Array.from(elements).forEach(function(element) {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      element.querySelector('.product-sizes-list').style.display = 'none';

    } else {
        element.addEventListener('mouseover', () => {
          if(queryString.length > 1){
            element.querySelector('.product-sizes-list').style.visibility = 'visible';
          }
        })
        element.addEventListener('mouseout', () => {
          element.querySelector('.product-sizes-list').style.visibility = 'hidden';
        })
	}
  })
}


var prevScrollpos = window.pageYOffset;
window.onscroll = function() {

  var currentScrollPos = window.pageYOffset;

  if (prevScrollpos > currentScrollPos) {
    document.getElementById("shopify-section-search-bar").style.top = "62px";
    document.getElementById("shopify-section-search-bar").style.zIndex  = "3";
  } else {
    var attr = document.getElementById("Search__ResultsMobile").getAttribute('aria-hidden');
    if (attr == "true") {
      document.getElementById("shopify-section-search-bar").style.top = "-56px";
    }
  }
  prevScrollpos = currentScrollPos;
}

function resultsHide() {
  document.getElementById("Search__ResultsMobile").setAttribute("aria-hidden", "true");
  document.getElementById("shopify-section-search-bar").style.top = "-56px";
  document.getElementById("Search__FormMobile").reset();
  document.getElementById("closeSearchBar").style.display = 'none';
}



timeout_var = null;

function typeWriter(selector_target, text_list, placeholder = false, i = 0, text_list_i=0, delay_ms=110) {
    if (!i) {
        if (placeholder) {
            document.querySelector(selector_target).placeholder = "";
        }
        else {
            document.querySelector(selector_target).innerHTML = "";
        }
    }
    txt = text_list[text_list_i];
    if (i < txt.length) {
        if (placeholder) {
            document.querySelector(selector_target).placeholder += txt.charAt(i);
        }
        else {
            document.querySelector(selector_target).innerHTML += txt.charAt(i);
        }
        i++;
        setTimeout(typeWriter, delay_ms, selector_target, text_list, placeholder, i, text_list_i);
    }
    else {
        text_list_i++;
        if (typeof text_list[text_list_i] === "undefined")  {
            setTimeout(typeWriter, (delay_ms*5), selector_target, text_list, placeholder);
        }
        else {
            i = 0;
            setTimeout(typeWriter, (delay_ms*10), selector_target, text_list, placeholder, i, text_list_i);
        }
    }
}

if (document.documentElement.lang === "en") {
  text_list = [
    "Cross body bag for her",
    "Leather shoulder bag",
    "Cross body bag for him",
    "Backpack for her"
  ];
} else {
  text_list = [
    "Bandoleras mujer",
    "Bolsos de piel",
    "Bandoleras hombre",
    "Mochilas mujer"
  ];  
}

return_value = typeWriter("#search_placeholder", text_list, true);
return_value = typeWriter("#inp3", text_list, true);


function toggleX() {
  var inp3 = document.getElementById("inp3").value;
  if(document.getElementById("inp3").value.trim() == ''){
    document.getElementById("closeSearchBar").style.display = 'none';
  } else {
    document.getElementById("closeSearchBar").style.display = 'block';
  }
}


const swiper = new Swiper('.swiper', {
  // Default parameters
  slidesPerView: 4,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 4,
      spaceBetween: 40
    }
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  }
})